import { lazy } from "react";

export { BPM_PROCESS_EDITOR_PATH } from "./ui/bpm-process-editor/bpm-process-editor-path";
export const BpmProcessEditorPage = lazy(
  () => import("./ui/bpm-process-editor/bpm-process-editor"),
);
